module.exports = __webpack_public_path__ + "fonts/Arnhem-Bold.8059395.woff2";